<template lang="pug">
    Row
        Col(span="11")
            Card.listCard(dis-hover)
                p(slot="title") {{formItem.appliedTitle}}
                List
                    draggable(
                        class="dragArea list-group"
                        v-model="formValue"
                        @change="formValue = removeDuplicateObject(formValue,'value')"
                        group="people"
                        v-bind="{animation: 200,group: 'description',disabled: false,ghostClass: 'ghost'}"
                        @start="drag = true"
                        @end="drag = false")
                        ListItem(
                            v-for="(element, idx) in formValue"
                            :key="`${idx}-${element.value}`")
                            Icon(type="md-reorder")
                            ListItemMeta(:description="element.value")
                            template(slot="action")
                                li
                                    i-switch(v-model="element.isEnabled")
                                        Icon(type="md-checkmark"
                                            slot="open")
                                        Icon(type="md-close"
                                            slot="close")
                                li
                                    JsonPoptip(
                                        :title="element.value" 
                                        :jsonData="options.find(e => e.value == element.value) ? options.find(e =>e.value == element.value).description  : {}"
                                        buttonText=""
                                        buttonIcon="md-eye"
                                    )
                                    // Poptip(:title="element.value"
                                    //     transfer)
                                    //     pre(
                                    //         style="text-align: left;"
                                    //         slot="content"
                                    //         v-html="JSON.stringify(options.find(e => e.value == element.value) ? options.find(e =>e.value == element.value).description  : '[]',null,2)")
                                    //     Button(icon="md-eye" size="small")
        Col(span="11" offset="2")
            Card.listCard(dis-hover)
                p(slot="title") {{formItem.availableTitle}}
                List
                    draggable(
                        class="dragArea list-group"
                        :list="options"
                        @change="options = removeDuplicateObject(options,'value')"
                        :group="{name: 'people',pull: 'clone', put: true}"
                        :sort="false")
                        ListItem(
                            v-for="(element, idx) in options"
                            :key="`${idx}-${element.value}`")
                            ListItemMeta(:description="element.value")
                            template(slot="action")
                                li
                                    JsonPoptip(
                                        :title="element.value" 
                                        :jsonData="element.description"
                                        buttonText=""
                                        buttonIcon="md-eye"
                                    )
                                    // Poptip(:title="element.value" transfer)
                                    //     pre(
                                    //         style="text-align: left;"
                                    //         slot="content"
                                    //         v-html="JSON.stringify(element.description,null,2)")
                                    //     Button(icon="md-eye" size="small")
</template>
<script>
import draggable from "vuedraggable";
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";
import JsonPoptip from "@/components/JsonPoptip";

export default {
    components: { draggable, JsonPoptip },
    props: ["formItem", "formData", "value"],
    data() {
        return {
            formValue: this.value,
            options: this.formItem.options,
            queryParamsFields: this.formItem.queryParamsFields
        };
    },
    watch: {
        formValue: function() {
            // console.log(this.formValue);
            this.$emit("input", this.formValue);
        }
    },
    methods: {
        removeDuplicateObject(options, objKey) {
            options = options.filter((e, i, a) => i === a.findIndex(t => t[objKey] === e[objKey]));
            return options;
        },
        async getRemoteOption(queryParams) {
            this.options = await this.formItem.remoteOptions(queryParams);
        }
    },
    mounted() {
        if (this.isRemoteOptions) {
            // 在意的欄位中, 只要一人符合 queryIf 條件, 即可以在 mounted 時獲取選項
            // 亦即: 所有在意的欄位都不符合時, 則不能在 mounted 時獲取選項
            let hasSomeFieldsMatch = this.queryParamsFields.some(field =>
                field.queryIf(this.formData[field.fieldName])
            );
            let canGetOptions = this.queryParamsFields.length == 0 || hasSomeFieldsMatch;
            if (canGetOptions) this.getRemoteOption(this.queryParams);
        }
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach(field => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function() {
                    return this.formData[fieldName];
                },
                function(newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    if (queryIf(newVal)) {
                        this.$emit("input", this.formItem.defaultVal);
                        this.getRemoteOption(this.queryParams);
                    }
                },
                { deep: true }
            );
        });
    },
    computed: {
        isRemoteOptions() {
            return typeof this.formItem.remoteOptions == "function";
        },
        queryParams() {
            let queryParams = {};
            this.queryParamsFields.forEach(field => {
                let { fieldName } = field;
                queryParams[fieldName] = this.formData[fieldName];
            });
            return queryParams;
        }
    }
};
</script>
<style lang="less" scoped>
.listCard {
    height: 500px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/TwoListDraggable.vue